@let fieldData = field();

<div class="output-request-file-cats mb-6">
  @if (fieldData.title) {
    <label
      class="block x-font-body-3 mb-2"
      [class.!font-extrabold]="fieldData.isHighlighted"
    >
      {{ fieldData.title }}
      @if (fieldData.helpText) {
        <tui-icon [tuiTooltip]="fieldData.helpText"></tui-icon>
      }
    </label>
  }

  <div class="space-y-2">
    <tui-accordion size="m">
      <button class="x-white" [tuiAccordion]="true">
        <div
          class="x-font-body-2-bold x-text-wf-text1 break-words whitespace-normal"
        >
          {{ getFileCatsNames() }}
        </div>
      </button>
      <tui-expand class="bg-white">
        @if (getAllFiles().length > 0) {
          <tui-scrollbar>
            <div class="flex gap-2 flex-nowrap md:flex-wrap">
              @for (fileCat of fieldData.fileCats; track fileCat.id) {
                @for (file of fileCat.files || []; track file.id) {
                  <!-- File icon -->
                  @if (isImage(file.filename)) {
                    <picture class="relative cursor-pointer">
                      <span
                        tuiAvatar="@tui.x-square"
                        size="l"
                        class="bg-[#F2F2F2]!"
                        [round]="false"
                        (click)="onFileClick(file)"
                      >
                        <img alt="" [src]="getFileUrl(file)" />
                      </span>
                    </picture>
                  } @else {
                    <picture class="doc-avatar">
                      <span
                        tuiAvatar="@tui.file"
                        size="l"
                        class="bg-[#F2F2F2]!"
                        tuiHintAppearance="dark"
                        [round]="false"
                        [tuiHint]="
                          ('request_form.files.hint_preview_image'
                            | translate) + file.filename
                        "
                        (click)="onFileClick(file)"
                      ></span>
                      <span class="file-extension typo-body-s bottom-0!">{{
                        getFileExtension(file.filename)
                      }}</span>
                    </picture>
                  }
                }
              }
            </div>
          </tui-scrollbar>
        } @else {
          <p class="text-sm text-gray-500 mt-2">Нет файлов</p>
        }
      </tui-expand>
    </tui-accordion>
  </div>
</div>

<!-- Image Preview Component -->
@if (request()) {
  <x-image-preview
    [files]="getAllFiles()"
    [showPreviewImageData]="showPreviewImageData"
    [request]="request()!"
    [viewOnly]="true"
  />
}
